module.exports = __webpack_public_path__ + "img/mira_790d_detail_rsh.b8535973.jpg";